import * as React from 'react';
import { Input, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

interface IProps {
	value: any;
	placeholder?: string;
	onChange?: any;
	id: string;
	type?: any;
	className?: string;
	isRequired?: boolean;
	isHover?: boolean;
	readonly?: boolean;
	onClick?: any;
}
interface IState {
	hoverClass: string;
}

class DABTextBoxWithSearch extends React.Component<IProps, IState>  {
	state = { hoverClass: "" };
	constructor(props: any) {
		super(props);
		this.state = {
			hoverClass: this.props.isHover === true ? "label-edit" : " "
		}
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnClick = this.handleOnClick.bind(this);
	}

	handleOnChange(event) {
		if (this.props.onChange) {
			this.props.onChange(event);
		}
	}

	handleOnClick(event) {
		if (this.props.onClick) {
			this.props.onClick(event);
		}
	}

	render() {
		return (
			<div style={{ float: "right" }}>
				<Row className="card-box" >
					<Col lg="9">
						<Input required={this.props.isRequired}
							type={this.props.type}
							className={"form-control " + this.state.hoverClass + " " + this.props.className}
							id={this.props.id} name={this.props.id}
							value={this.props.value}
							onChange={this.handleOnChange}
							readOnly={this.props.readonly}
						/>
					</Col>
					<Col lg="1">
						<FontAwesomeIcon size='2x' icon={faMagnifyingGlass} className="hover-cursor"
						onClick={this.handleOnClick} title="Search" data-bs-toggle="tooltip"
						data-bs-placement="bottom" />
					</Col>
				</Row>
			</div>
		)
	}
}

export default DABTextBoxWithSearch;